module.exports = __webpack_public_path__ + "media/theme/ico-close-1-112faa4d.png";